(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-note')) {
    customElements.define(
      'cart-note',
      class CartNote extends HTMLElement {
        constructor() {
          super();

          this.addEventListener(
            'change',
            debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            }, 300)
          );
        }
      }
    );
  }

  // Handle free sample Add buttons
  document.addEventListener('click', function (event) {
    const sampleAddButton = event.target.closest('.cart-drawer__free-sample-add');
    if (sampleAddButton && !sampleAddButton.disabled) {
      const variantId = sampleAddButton.dataset.variantId;
      if (!variantId) return;

      event.preventDefault();

      // Disable button and show loading state
      sampleAddButton.disabled = true;
      const originalText = sampleAddButton.textContent;
      sampleAddButton.textContent = 'Adding...';

      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerItems = document.querySelector('cart-drawer-items');

      if (!cartDrawer || !cartDrawerItems) {
        sampleAddButton.disabled = false;
        sampleAddButton.textContent = originalText;
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.method = 'POST';

      config.body = JSON.stringify({
        sections: cartDrawerItems.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
        items: [
          {
            id: parseInt(variantId),
            quantity: 1,
            properties: {
              _free_sample: 'true',
            },
          },
        ],
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            sampleAddButton.disabled = false;
            sampleAddButton.textContent = originalText;
            return;
          }

          cartDrawer.renderContents(response);
        })
        .catch(() => {
          sampleAddButton.disabled = false;
          sampleAddButton.textContent = originalText;
        });
      return;
    }

    // Handle recommendation Add buttons
    const addButton = event.target.closest('.cart-drawer__recommendation-add');
    if (!addButton || addButton.disabled) return;

    const variantId = addButton.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();

    // Disable button and show loading state
    addButton.disabled = true;
    const originalText = addButton.textContent;
    addButton.textContent = 'Adding...';

    const cartDrawer = document.querySelector('cart-drawer');
    const cartDrawerItems = document.querySelector('cart-drawer-items');

    if (!cartDrawer || !cartDrawerItems) {
      addButton.disabled = false;
      addButton.textContent = originalText;
      return;
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    config.method = 'POST';

    config.body = JSON.stringify({
      sections: cartDrawerItems.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
      items: [
        {
          id: parseInt(variantId),
          quantity: 1,
        },
      ],
    });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          addButton.disabled = false;
          addButton.textContent = originalText;
          return;
        }

        cartDrawer.renderContents(response);
      })
      .catch(() => {
        addButton.disabled = false;
        addButton.textContent = originalText;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
